import { IconMessageCircle, IconMessages } from "@tabler/icons-react"
import { type FC, type ReactNode } from "react"

type Props = { title: string; description: string; children?: ReactNode }
const CommunityEmptyState: FC<Props> = ({ title, description, children }) => (
	<div className="border-primary/15 bg-primary/5 flex flex-col items-center rounded-2xl border px-6 py-12 text-center sm:py-16">
		<div aria-hidden="true" className="relative mb-6 flex size-24 items-center justify-center">
			<div className="bg-primary/10 absolute inset-0 rounded-full" />
			<div className="border-primary/20 text-primary relative -rotate-6 rounded-2xl border bg-white p-4 shadow-sm">
				<IconMessages className="size-10" stroke={1.5} />
			</div>
			<div className="bg-primary absolute -right-2 bottom-0 rotate-12 rounded-xl p-2 text-white shadow-sm">
				<IconMessageCircle className="size-5" stroke={1.5} />
			</div>
		</div>
		<h2 className="text-xl font-semibold">{title}</h2>
		<p className="text-light mt-2 max-w-sm text-sm leading-relaxed">{description}</p>
		{children && <div className="mt-6">{children}</div>}
	</div>
)

export default CommunityEmptyState
